import React, { Component } from 'react'
import { PanelGroup, Panel } from 'react-bootstrap'
import MigrationKeyPanel from './MigrationKeyPanel'

class WPEngineFAQs extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.handleFAQSelect = this.handleFAQSelect.bind(this)
	}

	handleFAQSelect(activeFAQKey) {
		let _key = this.state.activeFAQKey
		if (_key && _key == activeFAQKey) {
			this.setState({ activeFAQKey: false })
		} else {
			this.setState({ activeFAQKey: activeFAQKey })
		}
	}

	render(){
		const { bvKeyMigrationEnabled } = this.props
		const { activeFAQKey } = this.state
		return (
			<div>
				<PanelGroup
					accordion
					id="wpengine"
					activeKey={activeFAQKey}
					onSelect={this.handleFAQSelect}
					bsClass="col-xs-10 col-md-10 bv-faq-accordion-list"
				>

				<Panel eventKey="1">
					<Panel.Heading bsClass="panel-heading">
						<Panel.Title toggle>
							<p className="bv-faq-que">
								{ activeFAQKey == "1" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
								What is Destination Site URL?
							</p>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<p className="bv-faq-ans">
							Destination Site URL of the site you are moving to.
							After logging in, you can find the <strong>Destination Site URL</strong> details on the <strong>overview page</strong>.
						</p>
					</Panel.Body>
				</Panel>

				<Panel eventKey="2">
					<Panel.Heading bsClass="panel-heading">
						<Panel.Title toggle>
							<p className="bv-faq-que">
								{ activeFAQKey == "2" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
								Where can I find my sFTP Details?
							</p>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<p className="bv-faq-ans">
							After logging in, click on <strong>sFTP Users</strong> in the <strong>side menu</strong>.
							This should reveal the sFTP host/server name, sFTP Username and Port.
						</p>
					</Panel.Body>
				</Panel>

				<Panel eventKey="3">
					<Panel.Heading bsClass="panel-heading">
						<Panel.Title toggle>
							<p className="bv-faq-que">
								{ activeFAQKey == "3" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
								Where can I find my sFTP Password?
							</p>
						</Panel.Title>
					</Panel.Heading>
					<Panel.Body collapsible>
						<p className="bv-faq-ans">
							If you don’t remember the password then you can create a new SFTP User altogether and enter those credentials here.
						</p>
					</Panel.Body>
				</Panel>
					{bvKeyMigrationEnabled ? <MigrationKeyPanel eventKey='4' activeFAQKey={activeFAQKey} /> : null}
			</PanelGroup>
			</div>
		)
	}
}

export default WPEngineFAQs
